<section class="forecast-section">
  <div class="forecast-header">
    <mds-dropdown-menu
      [text]="selectedScenario?.text ?? 'Select scenario'"
      [options]="scenarioOptions"
      [selectedValue]="selectedScenario ? [selectedScenario] : []"
      [minWidth]="'200px'"
      (selectedValueChange)="onScenarioChange($event)"
    ></mds-dropdown-menu>
    <mds-button (click)="onCreateScenario()" type="secondary">New scenario</mds-button>
  </div>

  @if (loading) {
    <div class="forecast-loader">
      <mds-loader></mds-loader>
    </div>
  }

  @if (!loading && kpiWidgets.length) {
    <app-forecast-kpi-cards [widgets]="kpiWidgets"></app-forecast-kpi-cards>
  }

  @if (!loading) {
    <div class="forecast-chart-container" [class.forecast-chart-container--empty]="!kpiWidgets.length">
      @if (kpiWidgets.length) {
        <div class="forecast-chart-area">
          <highcharts-chart
            class="forecast-chart"
            [Highcharts]="Highcharts"
            [options]="forecastChartOptions"
          ></highcharts-chart>
        </div>
        <app-forecast-legend></app-forecast-legend>
      } @else {
        <app-empty-chart
          title="No forecast scenarios available"
          description="Create a new scenario to see forecast data here"
        ></app-empty-chart>
      }
    </div>
  }
</section>
